<div class="card-selector">
  @if (title() || titleIcon()) {
    <div class="card-selector__title">
      @if (titleIcon()) {
        <i [class]="'icon ' + titleIcon()"></i>
      }
      @if (title()) {
        <p>{{ title() }}</p>
      }
    </div>
  }

  <ul class="card-selector__list">
    @for (option of options(); track option.id) {
      <li
        class="card-selector__list_item"
        [class.selected]="isSelected(option)"
        [class.disabled]="disabled() || option.disabled"
        (click)="selectOption(option)"
      >
        <div class="card-selector__card">
          @if (showIcon() && option.icon) {
            <div class="card-selector__icon">
              <i [class]="'icon ' + option.icon"></i>
            </div>
          }

          <div class="card-selector__info">
            <div class="card-selector__info-header">
              <span class="card-selector__label">{{ option.label }}</span>
              @if (option.badge) {
                <span
                  class="card-selector__badge"
                  [innerHTML]="option.badge"
                ></span>
              }
            </div>

            @if (showDescription() && option.description) {
              <span
                class="card-selector__description"
                [innerHTML]="processDescription(option.description)"
              ></span>
            }
          </div>

          <div class="card-selector__right">
            @if (showPrice() && option.price !== undefined) {
              <span class="card-selector__price">
                {{ option.price | formattedCurrency: currencyMinorUnit() }}
              </span>
            }
            <div class="card-selector__radio">
              <i
                class="icon"
                [class.icon-radio-checked]="isSelected(option)"
                [class.icon-radio-unchecked]="!isSelected(option)"
              ></i>
            </div>
          </div>
        </div>
      </li>
    }
  </ul>
</div>

